import { render, staticRenderFns } from "./DragAndDrop.vue?vue&type=template&id=c52b74ea&scoped=true&"
import script from "./DragAndDrop.vue?vue&type=script&lang=js&"
export * from "./DragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDrop.vue?vue&type=style&index=0&id=c52b74ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52b74ea",
  null
  
)

export default component.exports